import component from './en-US/component';
import globalHeader from './en-US/globalHeader';
import menu from './en-US/menu';
import pages from './en-US/pages';
import pwa from './en-US/pwa';
import settingDrawer from './en-US/settingDrawer';
import settings from './en-US/settings';

export default {
  'app.request.error.title.400': '404',
  'app.request.error.message.400': 'Page not found',
  'app.request.error.403': 'Forbidden',
  'app.request.error.404': 'Not Found',
  'app.request.error.500': 'Internal Server Error',
  'app.request.error.502': 'Bad Gateway',
  'app.request.error.503': 'Service Unavailable',
  'app.request.error.504': 'Gateway Timeout',
  'app.request.error-request': 'Request error!',
  'app.category.review': 'Review',
  'app.legend': 'Legend',
  'app.legend.independent_care': 'Independent',
  'app.legend.acute_care': 'Acute-Advanced',
  'app.legend.basic_care': 'Basic Support',
  'app.legend.requires_exp': 'Needs Follow-Up',
  'app.legend.caution_care': 'Caution-Moderate',
  'app.legend.condition_info': 'Condition Information',
  'app.legend.notable_care': 'Notable-Complex',
  'app.legend.required_info': 'Required Information',
  'app.estimate_cost': 'Estimated Cost',
  'app.per_hour_commonapp': 'per hour',
  'app.estimate_cost_commonapp': 'Estimated Hourly Rate',
  'app.estimate_cost.quote-id': 'Quote ID',
  'app.estimate_cost.secondary': 'Secondary Quote',
  'app.estimate_cost.secondary_minamalCare': 'Second Person - Minimal Care Required',
  'app.estimate_cost.secondary_minamalCare_commonapp': 'NOTE: PRICING FOR CARE RECIPIENT 1',
  'app.estimate_cost.contagion_cost': 'Contagion Estimated Cost',
  'app.estimate_cost.contagion_note':
    'Note: The regular rate will be used once the contagious status has ended.',
  'app.estimate_cost.note-1': 'Thank you for submitting your quote.',
  'app.estimate_cost.note-2':
    'Please check your email for your estimated quote cost and unique quote code.',
  'app.estimate_cost.note-3': 'An agency representative will contact you to review your quote.',
  'app.estimate_cost.note-4': 'To exit please close your browser.',
  'app.estimate_cost.note-5': `If you do not see the email in your inbox in a few minutes, please check your “junk mail” folder or “spam” folder.
Please mark the email message as not junk or spam so emails being sent from this address will be moved to its original folder automatically.`,
  'app.estimate_cost.note-6': `If you still don’t receive an email, then write to info@homecarequote.com or call (678)-809-9200 explaining the problem. 
We will answer your request as soon as possible.`,
  'app.estimate_cost.note-commonapp_6': `If you still don’t receive an email, then write to Info@MyHomeCareQuote.com explaining the problem.
We will answer your request as soon as possible.`,
  'app.estimate_cost.note-commonapp': "If you would like a PDF copy of this quote emailed to you, please provide an email address.",
  'app.estimate_cost.note-commonapp1': "No one will contact you unless you authorize it.",
  'app.estimate_cost.sendMailButton': 'Send',
  'app.button.back': 'Back',
  'app.button.next': 'Next',
  'app.button.save_draft': 'Save Draft & Complete Quote Later',
  'app.button.ask_for_call': 'Ask for help',
  'app.button.update.question': 'Save/Update New Response',
  'app.modal.yes': 'Yes',
  'app.modal.no': 'No',
  'app.suggestion.noCommunication.content': 'You indicated that {name} is not aware that care is being explored. Is there currently no communication with {name} about care?',
  'app.suggestion.correct': 'Correct',
  'app.suggestion.notCorrect': 'Not correct',
  'app.reassess.confirm.question': 'Are all of the answers shown above still accurate?',
  'app.reassess.confirm.yes': 'Yes, keep these answers and continue',
  'app.reassess.confirm.no': 'No, I need to make changes',
  'app.reassess.confirm.required': 'Please confirm whether the answers above are still accurate.',
  'app.reassess.previousAnswer': 'Previous answer',
  'app.contactMethod.needPhone': 'Please add a phone number or choose another contact method.',
  'app.contactMethod.needEmail': 'Please add an email address or choose another contact method.',
  'app.modal.sameAsRename.title': 'New contact added',
  'app.modal.sameAsRename.content': 'This contact is also used in other roles. Do you want to update them with new contact info?',
  'app.modal.sameAsRename.yes': 'Yes, update',
  'app.modal.sameAsRename.no': 'No, keep the previous person',
  'app.address.entered': 'You entered',
  'app.address.suggested': 'Suggested',
  'app.address.zipNotFound': "We couldn't find ZIP code {zip}. Please check it.",
  'app.address.streetNotFound': "We couldn't verify this street in ZIP code {zip}.",
  'app.address.streetNotFoundShort': 'Street not found',
  'app.address.notFound': 'Not found',
  'app.address.useSuggested': 'Use suggested',
  'app.address.keepEntered': 'Keep what I entered',
  'app.address.confirmCorrect': 'Yes, this is correct',
  'app.address.edit': 'Edit address',
  'app.modal.ask.title': 'Ask Agency for Help',
  'app.modal.ask.call_name': 'Full name',
  'app.modal.ask.call_phone': 'Phone number',
  'app.modal.ask.button.cancel': 'Cancel',
  'app.modal.ask.button.submit': 'Submit',
  'app.modal.ask.contact': 'What\'s the best time to contact?',
  'app.modal.saveDraft.title': 'Save Draft & Complete Quote Later',
  'app.modal.saveDraft_name': 'Full name',
  'app.modal.saveDraft_phone': 'Phone number',
  'app.modal.saveDraft_email': 'Email',
  'app.modal.saveDraft.button.cancel': 'Cancel',
  'app.modal.saveDraft.button.submit': 'Submit',
  'app.modal.saveDraft.note': "Thank you for using HomeCareQuote.",
  'app.modal.saveDraft.isCompleteQuoteLable': "Would you like to complete this quote yourself at a later time?",
  'app.modal.saveDraft.isContactLable': "Would you like a HomeCareQuote Representative to contact you to help complete your quote?",
  'app.modal.saveDraft.isNoContact': 'Please note this will end your HomeCareQuote session. You will not receive any further information or correspondence from HomeCareQuote. If you would like to start a new quote, please visit our website to begin your quote process.',
  'app.modal.saveDraft.isYesCompleteQuote': 'Please enter your email so a copy can be sent to you for completion at your convenience.',
  'app.modal.saveDraft.isYesContact': 'Please enter your contact info & a time you would like to be contacted',
  'app.modal.quote.title': 'Load your quote',
  'app.modal.quote.button.new': 'New Quote',
  'app.modal.quote.button.continue': 'Continue',
  'app.modal.quote.placeholder': 'Quote ID...',
  'app.modal.quote.required-continue':
    'Quote will be out of date after 3 months. You will be able to key in the old quote ID to populate the old quotes, edit and create the new quote.',
  'app.modal.pinStaff.title': 'Enter Staff PIN',
  'app.modal.pinStaff.label': 'Staff PIN',
  'app.modal.relQuestion.title': 'Confirmation',
  'app.modal.relQuestion.pleaseSelect': 'PLEASE SELECT',
  'app.modal.relQuestionChoiceConfirmSelect': 'You didn’t select this service under "{nameQuestion}". {p}Would you like to select it now?',
  'app.modal.relQuestionChoiceConfirmDeselect': 'You selected this service under "{nameQuestion}". {p}Would you like to deselect it?',
  'app.modal.confirmHeightWeight.content': 'Please confirm that the information you entered is accurate before we proceed.',
  'app.modal.siblingQuote.note': 'You are reassessing the secondary quote {secondQuote}. The primary quote is {primaryQuote}.',
  'app.modal.confirmOxygenSmoking.title': '⚠️ Safety Warning: Oxygen and Smoking Hazard',
  'app.modal.confirmAddress.title':'Confirm Your Address',
  'app.modal.confirmOxygenSmoking.content':'DANGER: Smoking in a home where oxygen is in use is extremely dangerous and a severe fire hazard. This critical safety issue MUST BE ADDRESSED, ACKNOWLEDGED, & NOTED by the care team before proceeding.',
  'app.scollNote': 'Scroll down for more choices.',
  'app.minimalsHourNote': 'Please note the service hours you selected are less than the agency’s minimum hours, and higher hourly rates may apply. Please confirm your service hours selection.',
  'app.label.additionalPersonCommonApp': 'Please select the second household care.',
  'app.label.other': "Other",
  'app.label.age': 'Age',
  'app.label.animal': 'Dogs, Cats, Birds, Pigs, Fish',
  'app.label.time': 'TIME',
  'app.label.selectAll': 'Select all that apply',
  'app.label.contact_me_on_date': 'CONTACT ME on DATE',
  'app.label.transfers.height': 'Care Recipient Height',
  'app.label.transfers.weight': 'Care Recipient Weight',
  'app.label.transfers.height.unit': '(inches)',
  'app.label.transfers.weight.unit': '(lbs)',
  'app.label.transfers.select': 'Select one of the following:',
  'app.label.transfers.option1': 'Care Recipient Partial Assist (can help some with the transfer)',
  'app.label.transfers.option2': 'Care Recipient Total Assist (cannot help at all with transfer)',
  'app.label.generalConcernsAll.label': "Smoker",
  'app.label.generalConcernsAll.option1': 'Smokes inside the home/car',
  'app.label.generalConcernsAll.option2': 'Smokes outside the home/car',
  'app.label.other.bathing': 'Please explain',
  'app.label.email': 'Email',
  'app.label.name': 'Name',
  'app.label.phone': 'Phone',
  'app.label.contact': 'Contact Time APPT',
  'app.lable.checkterm': "I agree to the ",
  'app.lable.term': "Terms & Conditions",
  'app.lable.returnHomeCareQuote': "Return to ",
  'app.lable.checkboxContactEmail': "I would like the communication via email to be sent to this email address.",
  'app.lable.confirmZipcode': "Did you mean the address is:",
  'app.lable.notFoundAddress': "Address cannot be found.",
  'app.lable.isHiddenPrice':"Do not include pricing in this quote",
  'app.tooltip.adl': "ADL - Activities of Daily Living (ADLs) include bathing, dressing, grooming, toileting, transferring, continence support, and eating/feeding assistance.",
  'app.tooltip.iadl': "IADL - Instrumental Activities of Daily Living (IADLs) include companionship, meal preparation, medication reminders, shopping, errands, and light household support.",
  'app.tooltip.adlNote': "ADL's (Activities of Daily Living)",
  'app.tooltip.iadlNote': "IADL's (Instrumental Activities of Daily Living)",
  'app.settings.powered-by': 'Powered by HCQ',
  'app.settings.validate-required': 'This field cannot be empty.',
  'app.settings.validate-required-DOB': 'Please fill in either DOB or Age.',
  'app.settings.validate-required-Petcare': 'Please fill one of them.',
  'app.settings.validate-required-zipcode': 'ZipCode is required',
  'app.settings.validate-email': 'Enter a valid Email.',
  'app.settings.validate-phone': 'The Phone Number is invalid.',
  'app.settings.validate-datetime':
    'The Time is invalid. Format MM/DD/YYYY HH:MM AM/PM (time zone ET, CT, PT, etc)',
  'app.settings.validate-time': 'The Time is invalid. Format HH:MM AM/PM',
  'app.settings.validate-date': 'Date is invalid. Format MM/DD/YYYY',
  'app.settings.validate-date-format': 'Format MM/DD/YYYY',
  'app.settings.validate-date-format_CA': 'Format YYYY/MM/DD',
  'app.settings.validate-datetime.feature': 'Date must be in the future.',
  'app.settings.validate-datetime.past': 'Date must be in the past.',
  'app.settings.validate-date.placeholder': 'MM/DD/YYYY',
  'app.settings.validate-time.placeholder': 'HH:MM AM/PM',
  'app.settings.validate-time.placeholder_commonapp': 'HH:MM AM/PM TZ',
  'app.settings.validate-timezone.placeholder': 'TZ',
  'app.settings.validate-incorrect': 'This field is incorrect',
  'app.settings.validate-confirm': 'Please confirm your information',
  'app.settings.optional.explanation': 'Explanation',
  'app.settings.reassessment': 'Reassessment Quote',
  'app.settings.reassessment.old-quote': 'The inputted quote',
  'app.settings.reassessment.existing-quote': 'Existing Quote Code?',
  'app.settings.reassessment.submit': 'Submit',
  'app.settings.reassessment.quote-code': 'Quote code: ',
  'app.settings.reassessment.message-not-newest':
    'is not the newest version, please confirm the quote you like to reassess.',
  'app.settings.select.placeholder': 'Select one',
  'app.settings.select.placeholder.street': 'Street',
  'app.settings.select.placeholder.apt': 'Apt/Suite',
  'app.settings.select.placeholder.city': 'City',
  'app.settings.select.placeholder.state': 'State',
  'app.settings.select.placeholder.zip': 'Zip Code',
  'app.settings.other': 'Other/Notes/Additional Details (Please use this area for any additional notes/information)',
  'app.settings.uncertain': 'Uncertain',
  'app.settings.more-information': 'More information',
  'app.settings.description': 'Description',
  'app.settings.callName': 'Name',
  'app.settings.callPhone': 'Phone number',
  'app.settings.validate-section': 'Please answer the highlighted question before continuing.',
  'app.settings.date.placeholder': 'MM/DD/YYYY',
  'app.settings.date.placeholderCA': 'YYYY/MM/DD',
  'app.settings.datetime.placeholder': 'MM/DD/YYYY HH:MM AM/PM (time zone ET, CT, PT, etc)',
  'app.settings.datetime.placeholderCA': 'YYYY/MM/DD HH:MM AM/PM (time zone ET, CT, PT, etc)',
  'app.settings.optional': '(optional)',
  'app.settings.validate-house-number': 'Please include the house number (e.g., 22 Main St).',
  'app.label.personCare': 'Personal Care',
  'app.label.personCare1': 'services include all Companion/Sitter',
  'app.label.personCare2': 'and the options shown (select all that apply):',
  'app.label.companion': 'Companion/Sitter',
  'app.label.companion1': 'services include options shown below (select all the apply).',
  'app.label.companion2': 'No Personal Care Services (ADL\'s) are included with Companion/Sitter: ',
  'page.term.accept': 'Accept',
  'page.term.decline': 'Decline',
  'page.term.notShowAgain': 'Do not show again',
  'page.term.reviewAgain.button': 'Review Terms and Conditions',
  'page.term.reviewAgain.title': 'Terms and conditions were not accepted',
  'page.review.title': 'Please check the accuracy of the quote.',
  'page.review.title-estimate': 'Confirmation on the Quote',
  'page.review.title-estimate-commonapp': 'Confirmation Of Your Quote',
  'page.review.button.secondary': 'Print Secondary Quote',
  'page.review.button.print-price': 'Submit Your Quote',
  'page.review.button.print-price.quote-id': 'Quote ID',
  'page.review.button.create-new-quote': 'Create a New Quote',
  'page.review.note': 'If you need to edit/change/fix a response, please click on the box you wish to update.',
  'page.quota-exceeded.title': 'Quota Exceeded',
  'page.quota-exceeded.description': 'Quote quota has been exceeded. Please extend your plan.',
  'page.zipcode-error.description': "Currently, service is not available in your area.",
  'page.zipcode-error.description2': "Please come back and try again at a later time.",
  'page.quota-exceeded.action': 'Renew Your Plan',
  'page.quota-expired.title': 'Plan Expired',
  'page.quota-expired.description': 'Plan is expired. Please renew your plan.',
  'page.quota-expired.action': 'Renew Your Plan',
  'page.quota-invalid.title': 'Quote invalid',
  'page.quota-invalid.description':
    'The provided Quote ID was found in our system but is not valid for use. Please try again with another Quote ID.',
  'page.quota-invalid.action': 'Contact HomeCareQuote',
  'page.quota-invalid.action_Myhomecare': 'Contact MyHomeCareQuote',
  'page.400.button.back': 'Back',
  'page.alert.expiration': 'This is Demo version. Expiration Date:',
  'app.lable.section': "Section",
  'app.care.index': 'Care Needs Index',
  'app.spectrum.placement': 'Spectrum Placement',
  'app.staffing.recommendation': 'Staffing Recommendation',
  "app.primary.quote": 'Primary Quote',
  "app.primaryIntake": '(Primary Intake)',
  "app.secondaryIntake": '(Secondary Intake)',
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...pages,
};
